<template>
    <el-dialog
        :visible="isShowInput"
        width="480px"
        title="输入经纬度"
        :append-to-body="true"
        :destroy-on-close="true"
        :close-on-click-modal='false'
        @close="close">
        <el-form class="form-wrap" ref="formPosition" :rules="rulesPosition" :model="formPosition" label-width="100px">
            <el-form-item label="经度" prop="longitude">
                <el-input v-model.trim="formPosition.longitude" placeholder="请输入经度" clearable></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
                <el-input v-model.trim="formPosition.latitude" placeholder="请输入纬度" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSave">确定</el-button>
                <el-button @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { validatelongitude, validatelatitude } from '@/utils/validate'
export default {
  typeName: 'SetLatLngDialog',
  filters: {
  },
  props: {
    isShowInput: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {
          longitude: '',
          latitude: ''
        }
      }
    }
  },
  data () {
    return {
      formPosition: {
        longitude: '',
        latitude: ''
      },
      rulesPosition: {
        longitude: [
          { required: true, message: '请输入经度', trigger: 'blur' },
          { validator: validatelongitude, trigger: 'change' }
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' },
          { validator: validatelatitude, trigger: 'change' }
        ]
      }
    }
  },
  created () {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        this.formPosition = val
      }
    }
  },
  computed: {
  },
  methods: {
    onSave () {
      this.$refs.formPosition.validate().then(() => {
        this.formPosition.longitude = +this.formPosition.longitude
        this.formPosition.latitude = +this.formPosition.latitude
        this.$emit('getlnglat', this.formPosition)
        this.close()
      })
    },
    close () {
      this.$emit('update:isShowInput', false)
    }
  }
}
</script>
<style scoped lang="scss">
</style>
